import { render, staticRenderFns } from "./JdsPanelTab.vue?vue&type=template&id=8e656000&scoped=true&"
import script from "./JdsPanelTab.vue?vue&type=script&lang=ts&"
export * from "./JdsPanelTab.vue?vue&type=script&lang=ts&"
import style0 from "./JdsPanelTab.vue?vue&type=style&index=0&id=8e656000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e656000",
  null
  
)

export default component.exports